<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.multiselect__input {
  color: #0d86ff !important;
}
input.multiselect__input {
  content: "Pilih Nama Level";
}
</style>
<template>
<div class="card">
    <header class="card-header bg-primary text-white d-flex align-items-center font-weight-bold"> 
        Master Sertifikasi Reguler 
        <button type="button" @click="$router.go(-1)" class="btn btn-md ml-auto mr-2 btn-info">Back</button>
    </header>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark h4"> Sertifikasi </header>
            <div class="card-body">
                <div class="form-group">
                    <label for="nama-sertifikasi" class="font-weight-bold">Nama Sertifikasi</label>
                    <input 
                        v-model="formData.namaSertifikasi" 
                        type="text" 
                        class="form-control" 
                        id="nama-sertifikasi" 
                        :class="{
                            'is-invalid': $v.formData.namaSertifikasi.$error,                     
                        }"
                        characterAllow="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM,. 1234567890-"
                        >
                </div>
                <div class="row">
                    <div class="col">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Level</label>
                        <multiselect 
                        v-model="level" 
                        @input="(value) => updateLevel(value)"
                        label="namaLevel"
                        :options="levelPeruntukan" 
                        :class="{'invalid-multiselect' : $v.formData.level.$error}"
                        :searchable="true" 
                        :close-on-select="true" 
                        :show-labels="false" 
                        placeholder="Pick a value"
                    ></multiselect>
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Biaya Pendaftaran</label>
                        <input type="text" class="form-control" 
                        v-model="formData.biayaPendaftaran" 
                        id="biaya-pendaftaran"
                        readonly
                        >
                    </div>
                </div>
                <br>
                <div class="form-group">
                    <label for="exampleFormControlSelect1" class="font-weight-bold">Status</label>
                    <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="modul-active" v-model="formData.status" value="1" class="custom-control-input">
                            <label class="custom-control-label" for="modul-active">Active</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="modul-inactive" v-model="formData.status" value="2" class="custom-control-input">
                            <label class="custom-control-label" for="modul-inactive" >Inactive</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlSelect1" class="font-weight-bold">Action</label>
                    <!-- <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="formData.flagSubmodul" id="subModul">
                            <label class="form-check-label" for="subModul">
                                Enable Submodul
                            </label>
                        </div>
                    </div> -->
                </div>
                <div class="form-group">
                    <label for="deskripsi-modul" class="font-weight-bold">Deskripsi Sertifikasi</label>
                    <textarea class="form-control" v-model="formData.deskripsiModul" :class="{'is-invalid': $v.formData.deskripsiModul.$error}" id="deskripsi-modul" cols="30" rows="10"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> <h4>Daftar Mata Ujian</h4>
                <span class="text-danger" v-if="$v.formData.rowMataUji.$error">
                  Mata Uji Kosong
                </span>
            </header> 
            <div class="card-body" v-for="(input,k) in formData.rowMataUji" :key="k">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Aksi</label>
                    <button type="button" v-show="k == 0" @click="addDaftarMataUji()" class="btn btn-md btn-info" style="margin-left:15px;">Tambah</button>
                    <button type="button" v-show="k > 0" @click="hapusMataUji(k)" class="btn btn-md btn-danger" style="margin-left:15px;">Hapus</button>
                </div>
                <div class="form-group row">
                    <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Modul</label>
                    <div class="col-sm-10" style="padding-left:40px;">
                        <input class="form-check-input" type="checkbox" v-model="input.subModul" value="set" :id="'subModul'+k">
                        <label class="form-check-label" :for="'subModul'+k">
                            Enable Submodul
                        </label>
                    </div>
                </div>
                <section v-if="!input.subModul">
                    <div class="form-group row">
                        <label for="inputEmail3" class="col-sm-2 col-form-label">Mata Ujian</label>
                        <div class="col-sm-10">
                        <multiselect 
                            v-model="input.dummyMataUji" 
                            :options="optionsMataUji" 
                            label="text"
                            :searchable="true" 
                            @input="(value) => updateMataUji(k, value)"
                            :close-on-select="true" 
                            :show-labels="false" 
                            placeholder="Pick a value"
                        ></multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Harga</label>
                        <div class="col-sm-10">
                        <input type="number" class="form-control" v-model="input.harga" id="Harga Mata Uji">
                        </div>
                    </div>
                </section>
                <section v-else>
                    <div class="form-group row">
                        <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Nama Mata Uji</label>
                        <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="input.namaMataUji">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputEmail3" class="col-sm-2 col-form-label">Mata Ujian 1</label>
                        <div class="col-sm-10">
                        <multiselect 
                            v-model="input.subModulMataUji[0].dummyMataUji" 
                            :options="optionsMataUji" 
                            @input="(value) => updateSUbModulMataUji(k, 0, value)"
                            label="text"
                            :searchable="true" 
                            :close-on-select="true" 
                            :show-labels="false" 
                            placeholder="Pick a value"
                        ></multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Harga</label>
                        <div class="col-sm-10">
                        <input type="number" class="form-control" v-model="input.subModulMataUji[0].harga" id="Harga Mata Uji">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputEmail3" class="col-sm-2 col-form-label">Mata Ujian 2</label>
                        <div class="col-sm-10">
                        <multiselect 
                            v-model="input.subModulMataUji[1].dummyMataUji" 
                            :options="optionsMataUji" 
                             @input="(value) => updateSUbModulMataUji(k, 1, value)"
                            label="text"
                            :searchable="true" 
                            :close-on-select="true" 
                            :show-labels="false" 
                            placeholder="Pick a value"
                        ></multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Harga</label>
                        <div class="col-sm-10">
                        <input type="number" class="form-control" v-model="input.subModulMataUji[1].harga" id="Harga Mata Uji">
                        </div>
                    </div>
                </section>
                
            </div> 

        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> <h4>Dokumen Persyaratan</h4>
                <span class="text-danger" v-if="$v.formData.syaratDokumen.$error">
                    Dokumen persyaratan kosong
                </span>
            </header>
            <div class="card-body" v-for="(input,k) in formData.syaratDokumen" :key="k">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="exampleFormControlInput1" class="font-weight-bold">Nama Dokumen</label>
                       <multiselect 
                        v-model="input.dummySyaratDokumen" 
                        :options="optionMasterDokumen" 
                        label="namaDokumen"
                        :close-on-select="true" 
                        @input="(value) => updateSyaratDokumen(k, value)"
                        :show-labels="false" 
                        placeholder="Pick a value">
                        </multiselect>
                    </div>
                    <div class="form-group col-md-5">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Status Dokumen</label>
                        <select v-model="input.statusRequired" class="form-control" id="exampleFormControlSelect1">
                            <option value="1">Wajib</option>
                            <option value="2">Opsional</option>
                        </select>
                    </div>
                    <div class="col-1 d-flex align-items-center mt-2">
                        <div class="btn btn-sm btn-success ml-2" @click="addSyaratDokumen()" v-show="k == 0">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </div>
                        <div class="btn btn-sm btn-danger ml-2" @click="hapusSyaratDokumen(k)" v-show="k > 0">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> 
                <h4>Dokumen Persyaratan Penerbitan Sertifikat</h4> 
                <span class="text-danger" v-if="$v.formData.syaratDokumenPenerbitan.$error">
                    Dokumen persyaratan Penerbitan kosong
                </span>
            </header>
            <div class="card-body" v-for="(input,k) in formData.syaratDokumenPenerbitan" :key="k">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="exampleFormControlInput1" class="font-weight-bold">Nama Dokumen</label>
                        <multiselect 
                        :options="optionMasterDokumen" 
                        label="namaDokumen"
                        v-model="input.dummySyaratDokumen" 
                        @input="(value) => updateSyaratDokumenPenerbitan(k, value)"
                        :close-on-select="true" 
                        :show-labels="false" 
                        placeholder="Pick a value"
                    ></multiselect>
                    </div>
                    <div class="form-group col-md-5">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Status Dokumen</label>
                        <select v-model="input.statusRequired"class="form-control" id="exampleFormControlSelect1">
                            <option value="1">Wajib</option>
                            <option value="2">Opsional</option>
                        </select>
                    </div>
                    <div class="col-1 d-flex align-items-center mt-2">
                        <div class="btn btn-sm btn-success ml-2" @click="addSyaratDokumenPenerbitan()" v-show="k == 0">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </div>
                        <div class="btn btn-sm btn-danger ml-2" @click="hapusSyaratDokumenPenerbitan(k)" v-show="k > 0">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
        <Button
          style="float:right"
          class="btn btn-md btn-success px-4 py-2"
          @click="submitForm()"
          color="success"
        >Simpan</Button>
        <br />
        <br />
      </div>
</div>
</template>
<script>

import { required, maxLength } from 'vuelidate/lib/validators';
import LevelService from "../../../services/datamaster/level.service";
import { MasterDokumen } from "../../../mixins/master/MasterDokumen";
import SertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service.new";
import { AlertUtils } from "../../../mixins/AlertUtils";

export default {
mixins: [MasterDokumen, AlertUtils],
data() {
    return {
        value:'',
        optionsMataUji: [], 
        formData: {
            namaSertifikasi:'',
            biayaPendaftaran:'',
            level:'',
            status:'1',
            flagRpl:false,
            flagSubmodul:false,
            deskripsiModul:'',
            rowMataUji:[
                {
                    idMataUji:"",
                    harga:0,
                    dummyMataUji:"",
                    namaMataUji:"",
                    subModul:false,
                    subModulMataUji: [
                        {
                            idMataUji:"",
                            harga:0,
                            dummyMataUji:"",
                            namaMataUji:"",
                        },
                        {
                            idMataUji:"",
                            harga:0,
                            dummyMataUji:"",
                            namaMataUji:"",
                        }
                    ]
                }
            ],
            syaratDokumen: [
                {
                    idMasterDokumen: "",
                    statusRequired : '1',
                    dummySyaratDokumen:"",
                    
                }
            ],
            syaratDokumenPenerbitan: [
                {
                    idMasterDokumen: "",
                    statusRequired : '1',
                    dummySyaratDokumen:""
                },
            ]
        },
        levelPeruntukan: {},
        level:''
        
    }   
},
validations: {
    formData: {
      namaSertifikasi: { 
        required,
        maxLength: maxLength(100)
      },
    //   biayaPendaftaran: {
    //     required,
    //     minValue:1
    //   },
      level: {
        required
      },
      status: {
        required
      },
      deskripsiModul: {
        required
      },
      rowMataUji: {
        $each: {
            idMataUji: {
                required
            }
        }
      },
      syaratDokumen: {
        $each: {
            idMasterDokumen: {
                required
            }
        }
      },
      syaratDokumenPenerbitan: {
        $each: {
            idMasterDokumen: {
                required
            }
        }
      }

    }    
},
mounted() {
    this.getMataUji()
    this.getLevel()
    this.getAllDokumen()
},
methods: {
    getMataUji() {
        var vm = this
        SertifikasiService.getMataUji()
            .then((res) => {
                vm.optionsMataUji = res.data.items;
                
            });
    },
    addDaftarMataUji() {
        this.formData.rowMataUji.push(
            {
                idMataUji:"",
                harga:0,
                dummyMataUji:"",
                namaMataUji:"",
                subModul:false,
                subModulMataUji: [
                    {
                        idMataUji:"",
                        harga:0,
                        dummyMataUji:"",
                        namaMataUji:"",
                    },
                    {
                        idMataUji:"",
                        harga:0,
                        dummyMataUji:"",
                        namaMataUji:"",
                    }
                ]
            }
        )    
    },
    hapusMataUji(k) {
        this.formData.rowMataUji.splice(k,1)
    },
    addSyaratDokumen() {
        this.formData.syaratDokumen.push(
            {
                idDokumenPendukung : "",
                idMasterDokumen: "",
                invalid_dokumen : false,
                statusRequired : '1',
                modelMultiSelect: [],
                dummySyaratDokumen: ""
            }
        )
    },
    addSyaratDokumenPenerbitan() {
        this.formData.syaratDokumenPenerbitan.push(
            {
                idDokumenPendukung : "",
                idMasterDokumen: "",
                invalid_dokumen : false,
                statusRequired : '1',
                modelMultiSelect: [],
                dummySyaratDokumen:""
            }
        )
    },
    hapusSyaratDokumenPenerbitan(k) {
        this.formData.syaratDokumenPenerbitan.splice(k,1);
    },
    hapusSyaratDokumen(k) {
        this.formData.syaratDokumen.splice(k,1);
    },
    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    submitForm() {
        // console.log(this.formData)
        this.processSubmit()
        this.$v.$touch();
        const falseFault = []
        // if(this.$v.formData.namaSertifikasi.$error) {
        //     falseFault.push(false)    
        // }

        // if(this.$v.formData.biayaPendaftaran.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.level.$error) {
              
        //     falseFault.push(false) 
        // }

        // if(this.$v.formData.namaSertifikasi.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.deskripsiModul.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.rowMataUji.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.syaratDokumen.$error) {
            
        //     falseFault.push(false)   
        // }

        // if(this.$v.formData.syaratDokumenPenerbitan.$error) {
              
        //     falseFault.push(false) 
        // }

        // if(falseFault.indexOf(false) == 0) {
        //     this.$swal.fire(
        //       "Error",
        //       "Item Data Kosong",
        //       "error"
        //     );
        //     return false;
        // } else {
        //     console.log(this.formData)
        //     // this.processSubmit()
        // }
    },
    processSubmit() {
        var vm = this;
        SertifikasiService.postSertifikasi(this.formData)
        .then((response) => {
            vm.alertSuccess();

            vm.$router.push({ path: "/sertifikasi-new/master-sertifikasi" });
        })
        .catch((error) => {
            console.log(error.response.data.message)
        });
    },
    updateLevel(value) {
        this.formData.level = value.idLevelAnggota
        this.formData.biayaPendaftaran = 'Rp. '+this.formatPrice(value.hargaLevel);
    },
    updateMataUji(k, value) {
        this.formData.rowMataUji[k].idMataUji = value.id
        this.formData.rowMataUji[k].namaMataUji = value.text
    },
    updateSUbModulMataUji(k, idx, value) {
        this.formData.rowMataUji[k].subModulMataUji[idx].idMataUji = value.id
        this.formData.rowMataUji[k].subModulMataUji[idx].namaMataUji = value.text
    },
    updateSyaratDokumen(k, value) {
        this.formData.syaratDokumen[k].idMasterDokumen = value.idMasterDokumen
    },
    updateSyaratDokumenPenerbitan(k, value) {
        this.formData.syaratDokumenPenerbitan[k].idMasterDokumen = value.idMasterDokumen
    },
    formatPrice(value) {
        if(isNaN(value)) {
            return '0.00';
        } else {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
